import {Component, OnInit} from '@angular/core';
import {ThemePalette} from '@angular/material/core';
import {ActivatedRoute, Router} from '@angular/router';
import {OttVoucherService} from '../../../services/ott-voucher/ott-voucher.service';
import {RedeemVoucherResponse} from '../../../interfaces/ott-voucher/RedeemVoucherResponse';

@Component({
  selector: 'app-voucher-processing',
  templateUrl: './voucher-processing.component.html',
  styleUrls: ['./voucher-processing.component.scss']
})
export class VoucherProcessingComponent implements OnInit {

  public loading = false;
  public paymentOptionsLoadedJustify = 'space-between !important';
  public color: ThemePalette = 'primary';
  public diameter = 50;
  public walletClass = '';
  paymentMethod = 'ott_voucher';
  paymentMethodStyling = `url('../../assets/icons/Payment_Cards/PaymentCard_ott_voucher.png') center`;

  public headerColor = '';

  constructor(private router: Router, private route: ActivatedRoute, private ottVoucherService: OttVoucherService) { }

  ngOnInit(): void {
    this.walletClass = 'wallet-method-container';
    this.loading = true;

    this.ottVoucherService.redeemVoucher(sessionStorage.getItem('voucherNumber'), sessionStorage.getItem('mobileNumber')).subscribe((data: RedeemVoucherResponse) => {
      if (data.success) {
        // handle success
        sessionStorage.setItem('voucher-transaction-successful', 'true');
        sessionStorage.setItem('voucherBalance', data.voucherBalance.toString());
        sessionStorage.setItem('voucherAmount', data.voucherAmount.toString());
      } else {
        // handle failure
        sessionStorage.setItem('voucher-transaction-successful', 'false');
        sessionStorage.setItem('voucher-failure-message', data.message);
      }
      this.router.navigate(['transaction-status']);
    });
  }

}
